var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7188 10.168L12.6309 16.959C12.4082 17.1445 12.1855 17.2188 12 17.2188C11.7773 17.2188 11.5547 17.1445 11.3691 16.9961L4.24414 10.168C3.87305 9.83398 3.87305 9.24023 4.20703 8.90625C4.54102 8.53516 5.13477 8.53516 5.46875 8.86914L12 15.1035L18.4941 8.86914C18.8281 8.53516 19.4219 8.53516 19.7559 8.90625C20.0898 9.24023 20.0898 9.83398 19.7188 10.168Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/DownArrow.72a1561e734ad505c497f09b9c26d76e.svg";
export { ForwardRef as ReactComponent };